// converts this ["hello","world", {format:"json", facet: ["a", "b"]}] into this "hello/world?format=json&facet=a&facet=b"
function arrayToPath(array) {
  const path = array.filter(function (x) {
    return typeof x !== "object";
  });
  const filter = array.filter(function (x) {
    return typeof x === "object";
  });
  const qs = [];
  filter.forEach(function (x) {
    for (const key in x) {
      if (x[key] instanceof Array) {
        x[key].forEach(function (y) {
          qs.push(key + "=" + encodeURIComponent(y));
        });
      } else {
        qs.push(key + "=" + encodeURIComponent(x[key]));
      }
    }
  });
  return path.join("/") + "?" + qs.join("&");
}

// originally from the npm project azure-search, updated to remove api-key and support a proxy intermediary
export default function (options, getToken) {
  if (!options) throw new Error("please supply the options object");
  if (!options.url)
    throw new Error("please supply the url of the search service");
  if (!options.version) options.version = "2017-11-11-Preview";

  const httpCall = async function (path, method, body, overrides, cb) {
    path.push({
      "api-version": options.version,
    });

    let payload = "";
    if (body) {
      payload = JSON.stringify(body);
    }

    const headers = new Headers({
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json",
      "Accept-Charset": "UTF-8",
    });

    try {
      const token = await getToken();
      headers.append("Authorization", token);
    } catch (err) {
      if (cb) {
        cb(err, null);
      }
      return;
    }

    if (options.headers) {
      for (const h in options.headers) {
        headers.append(h, options.headers[h]);
      }
    }
    if (overrides) {
      for (const x in overrides) {
        headers.append(x, overrides[x]);
      }
    }

    const url = new URL(options.url);
    const requestUrl = new URL(url.pathname + "/" + arrayToPath(path), url);

    const init = {
      method: method,
      headers: headers,
    };

    // Only add payload if there is some..
    if (payload) {
      init.body = payload;
    }

    try {
      const res = await fetch(requestUrl.toString(), init);

      if (!cb) return;

      // Detect HTTP error status codes
      let errorResponse = res.status < 200 || res.status > 206;

      let result = await res.text();

      // Requires result parsing
      if (!(overrides && overrides.Accept === "text/plain")) {
        try {
          result = result ? JSON.parse(result) : {};
        } catch (err) {
          return cb(
            "failed to parse JSON:\n" + err + "\n " + result,
            null,
            res
          );
        }

        // Azure Errors
        if (result.error) {
          errorResponse = true;
          result = result.error;
        }

        // Inject response status code
        // This is currently not populated by Azure
        if (errorResponse) {
          result.code = result.code || res.status;
        }
      }

      if (errorResponse) {
        cb(result, null, res);
      } else {
        cb(null, result, res);
      }
    } catch (err) {
      if (cb) {
        cb(err, null);
      }
    }
  };

  const execute = httpCall;

  const get = function (path, overrides, callback) {
    execute(path, "GET", null, overrides, callback);
  };
  const post = function (path, body, callback) {
    execute(path, "POST", body, null, callback);
  };
  const put = function (path, body, callback) {
    execute(path, "PUT", body, null, callback);
  };
  const del = function (path, callback) {
    execute(path, "DELETE", null, null, callback);
  };

  return {
    listIndexes: function (cb) {
      get(["indexes"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data.value, data);
      });
    },
    createIndex: function (schema, cb) {
      if (!schema) throw new Error("schema is not defined");
      post(["indexes"], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    getIndex: function (indexName, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      get(["indexes", indexName], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    testAnalyzer: function (indexName, data, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      post(["indexes", indexName, "analyze"], data, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data.tokens, data);
      });
    },
    getIndexStats: function (indexName, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      get(["indexes", indexName, "stats"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    deleteIndex: function (indexName, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      del(["indexes", indexName], function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },

    listIndexers: function (cb) {
      get(["indexers"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data.value, data);
      });
    },
    createIndexer: function (schema, cb) {
      if (!schema) throw new Error("schema is not defined");
      post(["indexers"], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    updateIndexer: function (indexerName, schema, cb) {
      if (!indexerName) throw new Error("indexName is not defined");
      if (!schema) throw new Error("schema is not defined");
      put(["indexers", indexerName], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    getIndexer: function (indexerName, cb) {
      if (!indexerName) throw new Error("indexName is not defined");
      get(["indexers", indexerName], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    getIndexerStatus: function (indexerName, cb) {
      if (!indexerName) throw new Error("indexerName is not defined");
      get(["indexers", indexerName, "status"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    deleteIndexer: function (indexerName, cb) {
      if (!indexerName) throw new Error("indexerName is not defined");
      del(["indexers", indexerName], function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    runIndexer: function (indexerName, cb) {
      if (!indexerName) throw new Error("indexerName is not defined");
      post(["indexers", indexerName, "run"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    resetIndexer: function (indexerName, cb) {
      if (!indexerName) throw new Error("indexerName is not defined");
      post(["indexers", indexerName, "reset"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },

    getDataSource: function (dataSourceName, cb) {
      if (!dataSourceName) throw new Error("dataSourceName is not defined");
      get(["datasources", dataSourceName], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },

    createDataSource: function (options, cb) {
      if (!options) throw new Error("options is not defined");
      post(["datasources"], options, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },

    updateDataSource: function (options, cb) {
      if (!options) throw new Error("options is not defined");
      if (!options.name) throw new Error("options.name is not defined");
      put(["datasources", options.name], options, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },

    deleteDataSource: function (dataSourceName, cb) {
      del(["datasources", dataSourceName], function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },

    addDocuments: function (indexName, documents, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!documents) throw new Error("documents is not defined");
      post(
        ["indexes", indexName, "docs", "index"],
        {
          value: documents,
        },
        function (err, data) {
          if (err) return cb(err, null, data);
          if (data && data.error) return cb(data.error, null, data);
          cb(null, data.value, data);
        }
      );
    },
    updateDocuments: function (indexName, documents, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!documents) throw new Error("documents is not defined");

      for (let i = 0; i < documents.length; i++) {
        documents[i]["@search.action"] = "merge";
      }

      post(
        ["indexes", indexName, "docs", "index"],
        {
          value: documents,
        },
        function (err, data) {
          if (err) return cb(err, null, data);
          if (data && data.error) return cb(data.error, null, data);
          cb(null, data.value, data);
        }
      );
    },
    uploadDocuments: function (indexName, documents, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!documents) throw new Error("documents is not defined");

      for (let i = 0; i < documents.length; i++) {
        documents[i]["@search.action"] = "upload";
      }

      post(
        ["indexes", indexName, "docs", "index"],
        {
          value: documents,
        },
        function (err, data) {
          if (err) return cb(err, null, data);
          if (data && data.error) return cb(data.error, null, data);
          cb(null, data.value, data);
        }
      );
    },
    deleteDocuments: function (indexName, keys, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!keys) throw new Error("keys is not defined");

      for (let i = 0; i < keys.length; i++) {
        keys[i]["@search.action"] = "delete";
      }

      post(
        ["indexes", indexName, "docs", "index"],
        {
          value: keys,
        },
        function (err, data) {
          if (err) return cb(err, null, data);
          if (data && data.error) return cb(data.error, null, data);
          cb(null, data.value, data);
        }
      );
    },
    updateOrUploadDocuments: function (indexName, documents, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!documents) throw new Error("documents is not defined");

      for (let i = 0; i < documents.length; i++) {
        documents[i]["@search.action"] = "mergeOrUpload ";
      }

      post(
        ["indexes", indexName, "docs", "index"],
        {
          value: documents,
        },
        function (err, data) {
          if (err) return cb(err, null, data);
          if (data && data.error) return cb(data.error, null, data);
          cb(null, data.value, data);
        }
      );
    },
    search: function (indexName, query, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!query) throw new Error("query is not defined");

      post(
        ["indexes", indexName, "docs", "search"],
        query,
        function (err, results, res) {
          if (err) return cb(err, null, results);
          if (results && results.error) return cb(results.error, null, results);
          cb(null, results.value, results, res);
        }
      );
    },

    proxySearch: function (indexName, query, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!query) throw new Error("query is not defined");

      post(["search", "test"], query, function (err, results, res) {
        if (err) return cb(err, null, results);
        if (results && results.error) return cb(results.error, null, results);
        cb(null, results.value, results, res);
      });
    },

    lookup: function (indexName, key, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!key) throw new Error("key is not defined");

      get(
        ["indexes", indexName, "docs('" + key + "')"],
        null,
        function (err, data) {
          if (err) return cb(err, null, data);
          if (data && data.error) return cb(data.error, null, data);
          cb(null, data, data);
        }
      );
    },

    count: function (indexName, cb) {
      if (!indexName) throw new Error("indexName is not defined");

      get(
        ["indexes", indexName, "docs", "$count"],
        {
          Accept: "text/plain",
        },
        function (err, data) {
          if (err) return cb(err, null, data);
          cb(null, parseInt(data.trim()), data);
        }
      );
    },

    suggest: function (indexName, query, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!query) throw new Error("query is not defined");

      get(
        ["indexes", indexName, "docs", "suggest", query],
        null,
        function (err, results) {
          if (err) return cb(err, null, results);
          if (results && results.error) return cb(results.error, null, results);
          cb(null, results.value, results);
        }
      );
    },
    updateIndex: function (indexName, schema, cb) {
      if (!indexName) throw new Error("indexName is not defined");
      if (!schema) throw new Error("schema is not defined");
      put(["indexes", indexName], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, null, data);
      });
    },

    createSynonymMap: function (schema, cb) {
      if (!schema) throw new Error("schema is not defined");
      post(["synonymmaps"], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    updateOrCreateSynonymMap: function (mapName, schema, cb) {
      if (!mapName) throw new Error("mapName is not defined");
      if (!schema) throw new Error("schema is not defined");
      put(["synonymmaps", mapName], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    getSynonymMap: function (mapName, cb) {
      if (!mapName) throw new Error("mapName is not defined");
      get(["synonymmaps", mapName], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    listSynonymMaps: function (cb) {
      get(["synonymmaps"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data.value, data);
      });
    },
    deleteSynonymMap: function (mapName, cb) {
      if (!mapName) throw new Error("mapName is not defined");
      del(["synonymmaps", mapName], function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, null, data);
      });
    },

    createSkillset: function (schema, cb) {
      if (!schema) throw new Error("schema is not defined");
      post(["skillsets"], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    updateOrCreateSkillset: function (skillsetName, schema, cb) {
      if (!skillsetName) throw new Error("skillsetName is not defined");
      if (!schema) throw new Error("schema is not defined");
      put(["skillsets", skillsetName], schema, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    getSkillset: function (skillsetName, cb) {
      if (!skillsetName) throw new Error("skillsetName is not defined");
      get(["skillsets", skillsetName], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data, data);
      });
    },
    listSkillsets: function (cb) {
      get(["skillsets"], null, function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, data.value, data);
      });
    },
    deleteSkillset: function (skillsetName, cb) {
      if (!skillsetName) throw new Error("skillsetName is not defined");
      del(["skillsets", skillsetName], function (err, data) {
        if (err) return cb(err, null, data);
        if (data && data.error) return cb(data.error, null, data);
        cb(null, null, data);
      });
    },

    then: function (res, rej) {
      const ret = {};
      Object.keys(this).forEach(function (key) {
        if (key !== "then" && key !== "catch") {
          ret[key] = function () {
            // eslint-disable-next-line prefer-rest-params
            const args = Array.from(arguments);
            const fn = this[key];
            return new Promise(function (resolve, reject) {
              args.push(function (err, value) {
                if (err) reject(err);
                else resolve(value);
              });
              fn.apply(this, args);
            });
          };
        }
      });
      return Promise.resolve(ret).then(res, rej);
    },
    catch: function (rej) {
      return this.then(null, rej);
    },
  };
}
